<ng-template #content>
  <ng-content />
</ng-template>

@switch (level()) {
  @case (1) {
    <h1 [ngClass]="extraClasses()">
      <ng-container *ngTemplateOutlet="content" />
    </h1>
  }
  @case (2) {
    <h2 [ngClass]="extraClasses()">
      <ng-container *ngTemplateOutlet="content" />
    </h2>
  }
  @case (4) {
    <h4 [ngClass]="extraClasses()">
      <ng-container *ngTemplateOutlet="content" />
    </h4>
  }
  @case (5) {
    <h5 [ngClass]="extraClasses()">
      <ng-container *ngTemplateOutlet="content" />
    </h5>
  }
  @case (6) {
    <h6 [ngClass]="extraClasses()">
      <ng-container *ngTemplateOutlet="content" />
    </h6>
  }
  @default {
    <h3 [ngClass]="extraClasses()">
      <ng-container *ngTemplateOutlet="content" />
    </h3>
  }
}
